module.exports = __webpack_public_path__ + "assets/tenbis_square-cef75d.svg";